// extracted by mini-css-extract-plugin
export default {"Checkbox":"checkbox_Checkbox__o+amp","input":"checkbox_input__Pzh07","checkBoxLabel":"checkbox_checkBoxLabel__mN4pE"};